import { borrowerTooltipText } from '../../../common/SharedFunctions';
import { Tooltip } from 'devextreme-react/tooltip';

export const onBorrowerCellRender = (e) => {
    const targetId = `got_borrower_${e.data.id}`;
    const text = borrowerTooltipText(e.data.borrower);
    return (
        <>
            <div
                data-tip
                data-for={targetId}
            >
                {e.data.borrowerEntity}
                {e.data.propertyCount > 1 && (
                    <span>
                        <b>&nbsp;[+{e.data.propertyCount}]</b>
                    </span>
                )}
            </div>
            <Tooltip
                target={`[data-for="${targetId}"]`}
                showEvent='mouseenter'
                hideEvent='mouseleave'
                hideOnOutsideClick={false}
            >
                {text}
            </Tooltip>
        </>
    );
};
